import { isCancelled } from "@asosteam/asos-web-request";
import isAppOnline from "../../providers/applicationOnlineStatusProvider";
import { ServiceError } from "../errors";
import { OFFLINE_ERROR_PAGE_DELAY_MS } from "../../constants";

export default ({ error: e }) => {
  if (!isAppOnline()) {
    return new Promise((_, reject) => {
      global.setTimeout(() => {
        reject(new ServiceError(e));
      }, OFFLINE_ERROR_PAGE_DELAY_MS);
    });
  }

  if (isCancelled(e)) {
    return null;
  }

  throw new ServiceError(e);
};
